// extracted by mini-css-extract-plugin
export default {"wrapper":"scroll-to-top-button_wrapper__PXPzE","scrollToTopButton":"scroll-to-top-button_scrollToTopButton__PUGKP","arrow":"scroll-to-top-button_arrow__WDHuL"};